import Services from '../../services';
export const getCredit = async () => {
  try {
    const result = await Services.getCredit();
    const cartablist = [...result.mainBusinessAmountSrvs.filter((a) => a), ...result.customerAmountSrvs.filter((a) => a)]
    let list = [];
    list = cartablist.map((val) => ({
      name: val?.guildSrv ? val?.guildSrv?.name : val?.walletName,
      label: val?.guildSrv ? val?.guildSrv?.name : val?.walletName,
      value: val?.guildSrv ? val?.guildSrv?.code : val?.wallet,
      id: val?.guildSrv ? val?.guildSrv?.code : val?.wallet,
      wallet: val?.wallet,
      guild: val?.guildSrv,
    }));
    return list;
  } catch (error) {
    return [];
  }
};
